// eslint-disable-next-line prettier/prettier
export type TimeSpan = `${string}:${string}:${string}`;

// eslint-disable-next-line prettier/prettier
export type TimeRange = `${TimeSpan}-${TimeSpan}`;

export enum Preposition {
    Before = "Before",
    After = "After",
}
